import { faUpDownLeftRight } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Draggable from 'react-draggable';
import { FeatureFlag } from './FeatureFlag.js';
import { Button } from '../components/Button/Button.js';

const FeatureFlagUI = ()=>{
    let clickable = true;
    const startDragHandler = ()=>{
        clickable = false;
        // NOTE: waiting the drop
        setTimeout(()=>{
            if (clickable) {
                window.location.href = FeatureFlag.createDisableUrlForFeature();
            }
        }, 100);
    };
    const stopDragHandler = ()=>{
        clickable = true;
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "position-absolute top-0 end-0 p-2",
        style: {
            zIndex: 9999
        }
    }, /*#__PURE__*/ React.createElement(Draggable, {
        onStart: startDragHandler,
        onStop: stopDragHandler
    }, /*#__PURE__*/ React.createElement(Button, {
        icon: /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
            size: "lg",
            icon: faUpDownLeftRight,
            style: clickable ? {
                opacity: 0.5
            } : {}
        }),
        variant: "danger",
        style: {
            opacity: 0.8
        },
        className: "p-2"
    }, "Feature Flag Modified")));
};

export { FeatureFlagUI };
//# sourceMappingURL=FeatureFlagUI.js.map
